



































































import Vue from 'vue'
import dayjs from 'dayjs'
import { state } from '../store'
import { oldTenants } from '../utils'
import { getUserInfo } from '@/utils/auth'
export default Vue.extend({
  props: {
    year: {
      type: Number,
      default: 2020,
    },
    month: {
      type: Number,
      default: 1,
    },
    days: {
      type: Array,
      // default: () => [],
    },
    shiftList: {
      type: Array,
    },
  },
  data() {
    return {
      firstDay: 0,
      dateList: [],
      today: dayjs(dayjs().format('YYYY-MM-DD')).valueOf(),
    }
  },
  computed: {
    isEdit() {
      return this.days.length > 0
    },
  },
  watch: {
    year() {
      this.dateList = []
      this.initList()
      this.mergeDays()
    },
    days: {
      handler() {
        this.dateList = []
        this.initList()
        this.mergeDays()
      },
      deep: true,
    },
  },
  created() {
    // console.log(this.$attrs)
    this.initList()
    this.mergeDays()
    // 监听选择日子
    if (this.$attrs.editable) {
      this.$bus.$on('select-day', (res) => {
        // console.log(res.map((item) => dayjs(item).format('YYYY-MM-DD')))
        this.dateList = this.dateList.map((item) => {
          if (res.includes(item.time) && !item.disabled) {
            return {
              ...item,
              selected: true,
            }
          } else {
            return {
              ...item,
            }
          }
        })
      })
      // 监听重置
      this.$bus.$on('reset-days', () => {
        // this.dateList = []
        // this.initList()
        // this.mergeDays()
        this.dateList = this.dateList.map((item) => ({
          ...item,
          arranged: false,
        }))
      })
      // 监听分配
      this.$bus.$on('arrange-days', (shift) => {
        this.dateList = this.dateList.map((item) => {
          if (item.selected) {
            if (shift.id === '-1') {
              return {
                ...item,
                arranged: false,
                selected: false,
                shift: {},
              }
            } else {
              return {
                ...item,
                arranged: true,
                selected: false,
                shift,
              }
            }
          } else {
            return { ...item }
          }
        })
      })

      this.$bus.$on('cancel-arrange', () => {
        this.dateList = this.dateList.map((item) => {
          if (item.selected) {
            return {
              ...item,
              arranged: false,
              selected: false,
              prioritized: false,
              shift: {},
            }
          } else {
            return { ...item }
          }
        })
      })
      // 监听取消选择
      this.$bus.$on('cancel-select', () => {
        this.dateList = this.dateList.map((item) => ({
          ...item,
          selected: false,
        }))
      })

      this.$bus.$on('set-priority', () => {
        const temp = []
        for (let i = 0; i < this.dateList.length; i++) {
          if (this.dateList[i].selected && this.dateList[i].arranged) {
            temp[i] = {
              ...this.dateList[i],
              prioritized: true,
              selected: false,
            }
          } else if (!this.dateList[i].selected) {
            temp[i] = { ...this.dateList[i] }
            continue
          } else if (!this.dateList[i].arranged) {
            this.$message.info(this.$t('page_console_calendar_after_set'))
            return
          }
        }
        this.dateList = [...temp]
      })

      this.$bus.$on('cancel-priority', () => {
        this.dateList = this.dateList.map((item) => {
          if (item.selected) {
            return {
              ...item,
              prioritized: false,
              selected: false,
            }
          } else {
            return { ...item }
          }
        })
      })
    }
  },
  beforeDestroy() {
    if (this.$attrs.editable) {
      this.$bus.$off('select-day')
      this.$bus.$off('reset-days')
      this.$bus.$off('cancel-select')
    }
  },
  methods: {
    getMonth(month){
      return Number(month) > 9 ? month : '0' + month
    },
    initList() {
      const { tenant_id } = getUserInfo()
      const { year, month } = this
      const firstDay = dayjs(`${year}-${month > 9 ? month : '0' + month}-01`)
      const blankNumber = firstDay.day() === 0 ? 7 : firstDay.day()
      for (let i = blankNumber - 1; i > 0; i--) {
        const day = firstDay.add(-i, 'day')
        this.dateList.push({
          index: day.format('DD'),
          time: day.valueOf(),
          day: day.day(),
          disabled: true,
          selected: false,
          arranged: false,
          prioritized: false,
          shift: {},
        })
      }
      let computedMonth = month
      let date = firstDay
      let j = 1
      while (computedMonth === month) {
        this.dateList.push({
          index: j++,
          time: date.valueOf(),
          day: date.day(),
          disabled: this.$attrs.editable
            ? this.isEdit
              ? Number(dayjs().format('HH')) > 22
                ? date.isBefore(dayjs(this.today).add(2, 'day'))
                : date.isBefore(dayjs(this.today).add(1, 'day'))
              : oldTenants.includes(tenant_id)
              ? false
              : date.isBefore(dayjs(this.today))
            : false,
          selected: false,
          arranged: false,
          prioritized: false,
          shift: {},
        })
        date = date.add(1, 'day')
        computedMonth = date.month() + 1
      }
    },
    mergeDays() {
      for (let i = 0; i < this.days.length; i++) {
        for (let j = 0; j < this.dateList.length; j++) {
          if (
            !this.dateList[j].disabled &&
            dayjs(dayjs(this.days[i].calendarDate).format('YYYY-MM-DD')).valueOf() === this.dateList[j].time
          ) {
            const shift = this.shiftList.find((item) => {
              return item.id === this.days[i].modelId
            })
            this.dateList[j] = {
              ...this.dateList[j],
              arranged: true,
              prioritized: this.days[i].isHighPriority === 1,
              shift: {
                id: this.days[i].modelId,
                name: this.days[i].modelName,
                colour: shift ? shift.colour : 'grey',
              },
            }
          }
        }
      }
    },
    onSelect(obj) {
      if (!this.$attrs.editable || obj.disabled) return
      this.dateList = this.dateList.map((item) => {
        if (item.index === obj.index) {
          return { ...item, selected: !obj.selected }
        } else {
          return item
        }
      })
    },
    collectArrangedDays() {
      return this.dateList.filter((item) => typeof item.index === 'number')
    },
  },
})
